import { useState } from 'react'
import { useTenant } from '@/contexts/TenantContext'
import styles from './TenantIdentity.module.css'

type Props = {
  /** Mostrar identificador técnico (slug) — útil em login admin/profissional */
  showSlug?: boolean
  compact?: boolean
  className?: string
  /** Pré-visualização do nome antes de guardar */
  nomeOverride?: string
}

export function TenantIdentityCard({ showSlug = false, compact = false, className, nomeOverride }: Props) {
  const { nome, slug, logoUrl, loading, error } = useTenant()
  const displayNome = (nomeOverride ?? nome).trim() || nome
  const [logoFailed, setLogoFailed] = useState(false)
  const showLogo = logoUrl && !logoFailed

  if (loading && !nome) {
    return (
      <div className={[styles.card, compact && styles.cardCompact, className].filter(Boolean).join(' ')}>
        <p className={styles.loading}>A carregar empresa…</p>
      </div>
    )
  }

  return (
    <div
      className={[styles.card, compact && styles.cardCompact, className].filter(Boolean).join(' ')}
      role="status"
      aria-label={`Empresa: ${displayNome}`}
    >
      {showLogo ? (
        <img
          src={logoUrl}
          alt=""
          className={styles.logo}
          onError={() => setLogoFailed(true)}
        />
      ) : (
        <span className={styles.logoFallback} aria-hidden>
          {displayNome.charAt(0).toUpperCase()}
        </span>
      )}
      <div className={styles.text}>
        <span className={styles.label}>Empresa</span>
        <strong className={styles.nome}>{displayNome}</strong>
        {showSlug && <span className={styles.slug}>Identificador: {slug}</span>}
        {error && <span className={styles.hint}>{error}</span>}
      </div>
    </div>
  )
}
